import React from "react";
import { withStyles } from "@material-ui/core";
import { size, filter, get, forEach } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';

import SchedulerOccurrenceView from "../SchedulerOccurrenceView/SchedulerOccurrenceView";
// import { I18n } from "aws-amplify";

import { formatDate } from "../../../utils/date";
import { darkenColor } from "../../../utils/color";
import { getAttributeValue } from "../../../utils/profile";
import {
  getOccurrenceArrival,
  getOccurrenceDeparture,
  getOccurrenceEnd,
  getOccurrenceStart,
  getOverlapExceptionsCountSingle,
} from "../../../utils/scheduler";

import { calendarViews } from "../../../constants/common";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  container: {
    position: "absolute",
    zIndex: 99,
    cursor: "pointer",
  },
  containerWeekly: {
    width: "57px",
  },
  containerDaily: {
    width: "57px",
  },
  time: {
    fontSize: "0.857em",
    height: "16px",
    width: "100%",
    textAlign: "center",
  },
  dataColumnWeekly: {
    width: "19px",
  },
  dataColumnDaily: {
    width: "19px",
    "& img": {
      padding: "0px 4px",
    },
  },
  textWeekly: {
    textOrientation: "upright",
    writingMode: "vertical-lr",
    letterSpacing: "-0.3em",
    fontSize: "0.857em",
  },
  textDaily: {
    fontSize: "0.857em",
    textOrientation: "upright",
    writingMode: "vertical-lr",
    letterSpacing: "-0.3em",
  },
};

const SchedulerException = (props) => {
  const {
    classes,
    group,
    refresh,
    timeSlots,
    timeSlotHeights,
    calendarView,
    exceptions,
    index,
    end,
    type
  } = props;
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [del,  setDel] = React.useState(false);

  // const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const occurrenceStart = getOccurrenceArrival(group);
  const occurrenceEnd = getOccurrenceDeparture(group);

  if (!occurrenceStart || !occurrenceEnd) return null;

  const calculateExceptionTimeslotOffsetHeight = (
    offset,
    exceptionHeight,
    timeSlotStart,
    timeSlotEnd,
    timeSlotHeight,
    exceptionStart,
    exceptionEnd
  ) => {
    // Offset
    let newOffset = 0;
    if (timeSlotEnd <= exceptionStart) {
      newOffset = timeSlotHeight;
    } else if (
      timeSlotStart <= exceptionStart &&
      timeSlotEnd >= exceptionStart
    ) {
      newOffset =
        (timeSlotHeight * (exceptionStart - timeSlotStart)) /
        (timeSlotEnd - timeSlotStart);
    }

    // Height
    let newHeight = 0;
    // Case 1 - Exception inside the timeslot
    if (
      timeSlotStart <= exceptionStart &&
      timeSlotEnd >= exceptionStart &&
      timeSlotStart <= exceptionEnd &&
      timeSlotEnd >= exceptionEnd
    ) {
      newHeight =
        (timeSlotHeight * (exceptionEnd - exceptionStart)) /
        (timeSlotEnd - timeSlotStart);
    }
    // Case 2 - Exception starts in timeslot but ends after
    else if (
      timeSlotStart <= exceptionStart &&
      timeSlotEnd >= exceptionStart &&
      exceptionEnd > timeSlotEnd
    ) {
      newHeight =
        (timeSlotHeight * (timeSlotEnd - exceptionStart)) /
        (timeSlotEnd - timeSlotStart);
    }
    // Case 3 - Exception ends in timeslot but starts before
    else if (
      timeSlotStart <= exceptionEnd &&
      timeSlotEnd >= exceptionEnd &&
      exceptionStart < timeSlotStart
    ) {
      newHeight =
        (timeSlotHeight * (exceptionEnd - timeSlotStart)) /
        (timeSlotEnd - timeSlotStart);
    }
    // Case 4 - Exception Starts before and ends after timeslot
    else if (exceptionStart < timeSlotStart && exceptionEnd > timeSlotEnd) {
      newHeight = timeSlotHeight;
    }

    return [offset + newOffset, exceptionHeight + newHeight];
  };

  const interTimeSlotsHeight = 28;

  const startHours = getOccurrenceStart(group).hours();
  const endHours = getOccurrenceEnd(group).hours();
  const startMinutes = getOccurrenceStart(group).minutes();
  const endMinutes = getOccurrenceEnd(group).minutes();
  var offsetTop;
  if (end >= 23){
    offsetTop = -44;
  } else {
    offsetTop = props.offsetTop || 0;
  }
  
  let exceptionHeight = 0;
  forEach(timeSlots, (t, i) => {
    [offsetTop, exceptionHeight] = calculateExceptionTimeslotOffsetHeight(
      offsetTop,
      exceptionHeight,
      t.start.hours + t.start.minutes / 60,
      t.end.hours + t.end.minutes / 60,
      get(timeSlotHeights, [i]),
      startHours + startMinutes / 60,
      endHours + endMinutes / 60
    );
    if (get(timeSlots, [i + 1])) {
      [offsetTop, exceptionHeight] = calculateExceptionTimeslotOffsetHeight(
        offsetTop,
        exceptionHeight,
        t.end.hours + t.end.minutes / 60,
        get(timeSlots, [i + 1, "start", "hours"]) +
          get(timeSlots, [i + 1, "start", "minutes"]) / 60,
        interTimeSlotsHeight,
        startHours + startMinutes / 60,
        endHours + endMinutes / 60
      );
    }
  });

  const hostProfile = get(
    filter(
      get(occurrenceStart, ["profiles"]),
      (p) => get(p, ["association_type", "id"]) === 1
    ),
    [0, "profile"]
  );

  const backgroundColor =
    get(occurrenceStart, ["zones", 0, "zone", "color", "rgb"]) ||
    get(occurrenceStart, ["zones", 0, "zone", "type", "color", "rgb"]);
  const borderColor = darkenColor(backgroundColor, 15);

  const offsetRight =
    (getOverlapExceptionsCountSingle(group, exceptions) *
    index *
    (calendarView === calendarViews.weekly ? 60  : 60))/(Math.max(exceptions.length-1, 1));
  // function groupExceptions(exceptions){
  //   var exceptionGrouped = []
  //   console.log(exceptions)
  //   return exceptionGrouped
  // }
  // groupExceptions(exceptions)
  // const offsetRight =
  // getOverlapExceptionsCountSingle(group, exceptions) *
  // index *
  // (calendarView === calendarViews.weekly ? 60  : 104)/3

  function MouseOver(event) {
    var id = event.target.id;
    var allContainers = document.querySelectorAll('[name^="muigridcontainer"]')
    var allContainers_round = document.querySelectorAll('[name^="roundicon"]')

    for (var i=0;i<size(allContainers);i++){
      if (allContainers[i]["id"] === id){
        allContainers[i].style.outline = "0.5px solid #5f00a0"
        allContainers[i].style.outlineOffset = "-0.5px"
        allContainers[i].style.borderLeft = `3px solid ${borderColor}`
      }
    }

    for (i=0;i<size(allContainers_round);i++){
      if (allContainers_round[i]["id"] === id+"round"){
        allContainers_round[i].style.visibility = "visible"
      }
    }
  }
  function MouseOut(event){
    var id = event.target.id;
    var allContainers = document.querySelectorAll('[name^="muigridcontainer"]')
    var allContainers_round = document.querySelectorAll('[name^="roundicon"]')

    for (var i=0;i<size(allContainers);i++){
      if (allContainers[i]["id"] === id){
        allContainers[i].style.outline = "none"
        allContainers[i].style.outlineOffset = "-0.5px"
        allContainers[i].style.borderLeft = `3px solid ${borderColor}`
      }
    }

    for (i=0;i<size(allContainers_round);i++){
      if (allContainers_round[i]["id"] === id+"round"){
        allContainers_round[i].style.visibility = "hidden"
      }
    }
  }
  if (type === "day"){
    return (
      <Grid
        item
        className={clsx(classes.container, {
          [classes.containerWeekly]: calendarView === calendarViews.weekly,
          [classes.containerDaily]: calendarView === calendarViews.daily,
        })}
        onMouseOver={MouseOver}
        onMouseOut={MouseOut}
        name="muigridcontainer"
        id={occurrenceStart["id"]}
        style={{
          border: !backgroundColor ? `1px solid ${colors.black}` : "none",
          borderLeft: `3px solid ${borderColor}`,
          backgroundColor: backgroundColor ? `#${backgroundColor}` : colors.white,
          top: offsetTop,
          right: offsetRight,
          maxHeight: exceptionHeight,
        }}
      >
        {open && (
          <SchedulerOccurrenceView
            open={open}
            setOpen={setOpen}
            occurrence={group}
            timeSlots={timeSlots}
            refresh={refresh}
            customTimeSlot={true}
            edit={edit}
            del={del}
          />
        )}
        <Grid item name="roundicon" className={classes.iconItem} id={occurrenceStart["id"]+"round"} style={{visibility:"hidden", height:"0px"}}>
              <img src={images.round} id={occurrenceStart["id"]} alt="round_icon" style={{position: "relative", left: "38px", top:"-9px"}} onClick={() => { setEdit(true); setDel(false); setOpen(true)}}/>
        </Grid>
        {/* <Grid item id={occurrenceStart["id"]+"menu"} style={{position: "relative",top:"-7.5px", visibility:"visible"}}>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={() => { handleClose(); setEdit(true); setDel(false); setOpen(true)}}>{I18n.get("edit")}</MenuItem>
                <MenuItem style={{color:"red"}} onClick={()=>{handleClose(); setEdit(true); setDel(true); setOpen(true)}}>{I18n.get("delete")}</MenuItem>
              </Menu>
        </Grid> */}
        <Grid container direction="column" wrap="nowrap" id={occurrenceStart["id"]} onClick={() => setOpen(true)}>
          <Grid
            item
            className={classes.time}
            id={occurrenceStart["id"]}
            style={{
              backgroundColor: borderColor,
              borderBottom: !backgroundColor
                ? `1px solid ${colors.veryLighPink}`
                : "none",
            }}
          >
            {formatDate(getOccurrenceStart(group), "hh:mm a")}
          </Grid>
          <Grid
            item
            id={occurrenceStart["id"]}
            style={{
              padding: "4px 0px",
              height: exceptionHeight - 40,
              display: exceptionHeight - 40 < 0 ? "none" : "",
              overflow: "hidden",
            }}
          >
            <Grid
              container
              // style={{position:"relative", left: "25px"}}
              id={occurrenceStart["id"]}
            >
              <Grid
                item
                id={occurrenceStart["id"]}
                className={clsx({
                  [classes.dataColumnDaily]: calendarView === calendarViews.daily,
                  [classes.dataColumnWeekly]:
                    calendarView === calendarViews.weekly,
                })}
              >
                <Grid
                  container
                  id={occurrenceStart["id"]}
                  alignItems="center"
                  wrap="nowrap"
                >
                  <Grid
                    item
                    id={occurrenceStart["id"]}
                    className={clsx({
                      [classes.textDaily]: calendarView === calendarViews.daily,
                      [classes.textWeekly]: calendarView === calendarViews.weekly,
                    })}
                  >
                    <img src={images.humanIconBlack} alt="human" height="12px" id={occurrenceStart["id"]} />
                    &nbsp;
                    {`${get(hostProfile, ["firstname"])} ${get(hostProfile, [
                      "lastname",
                    ])}`}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                id={occurrenceStart["id"]}
                className={clsx({
                  [classes.dataColumnDaily]: calendarView === calendarViews.daily,
                  [classes.dataColumnWeekly]:
                    calendarView === calendarViews.weekly,
                })}
              >
                <Grid
                  container
                  id={occurrenceStart["id"]}
                  alignItems="center"
                  wrap="nowrap"
                >
                  <Grid
                    item
                    id={occurrenceStart["id"]}
                    className={clsx({
                      [classes.textDaily]: calendarView === calendarViews.daily,
                      [classes.textWeekly]: calendarView === calendarViews.weekly,
                    })}
                  >
                    <img src={images.locationIcon} alt="location" height="12px" id={occurrenceStart["id"]} />
                    &nbsp;
                    {get(occurrenceStart, ["zones", 0, "zone", "name"])}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                id={occurrenceStart["id"]}
                className={clsx({
                  [classes.dataColumnDaily]: calendarView === calendarViews.daily,
                  [classes.dataColumnWeekly]:
                    calendarView === calendarViews.weekly,
                })}
              >
                <Grid
                  container
                  id={occurrenceStart["id"]}
                  alignItems="center"
                  wrap="nowrap"
                >
                  <Grid
                    item
                    id={occurrenceStart["id"]}
                    className={clsx({
                      [classes.textDaily]: calendarView === calendarViews.daily,
                      [classes.textWeekly]: calendarView === calendarViews.weekly,
                    })}
                  >
                    <img
                      id={occurrenceStart["id"]}
                      src={images.pedestrianIcon}
                      alt="pedestrian"
                      height="12px"
                    />
                    &nbsp;
                    {size(
                      filter(
                        get(occurrenceStart, ["profiles"]),
                        (p) => get(p, ["association_type", "id"]) === 2
                      )
                    )}
                  </Grid>
                  {getAttributeValue(occurrenceStart, 19) && (
                    <Grid item style={{ marginTop: "24px" }} id={occurrenceStart["id"]}>
                      <img src={images.commentIconBlack} alt="comments" />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            id={occurrenceStart["id"]}
            className={classes.time}
            style={{
              backgroundColor: borderColor,
              borderTop: !backgroundColor
                ? `1px solid ${colors.veryLighPink}`
                : "none",
            }}
          >
            {formatDate(getOccurrenceEnd(group), "hh:mm a")}
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        className={clsx(classes.container, {
          [classes.containerWeekly]: calendarView === calendarViews.weekly,
          [classes.containerDaily]: calendarView === calendarViews.daily,
        })}
        onMouseOver={MouseOver}
        onMouseOut={MouseOut}
        name="muigridcontainer"
        id={occurrenceStart["id"]}
        style={{
          border: !backgroundColor ? `1px solid ${colors.black}` : "none",
          borderLeft: `3px solid ${borderColor}`,
          backgroundColor: backgroundColor ? `#${backgroundColor}` : colors.white,
          top: offsetTop,
          right: offsetRight,
          maxHeight: exceptionHeight,
        }}
      >
        {open && (
          <SchedulerOccurrenceView
            open={open}
            setOpen={setOpen}
            occurrence={group}
            timeSlots={timeSlots}
            refresh={refresh}
            customTimeSlot={true}
            edit={edit}
            del={del}
          />
        )}
        <Grid item name="roundicon" className={classes.iconItem} id={occurrenceStart["id"]+"round"} style={{visibility:"hidden", height:"0px"}}>
              <img src={images.round} id={occurrenceStart["id"]} alt="round_icon" style={{position: "relative", left: "38px", top:"-7px", width:"25px", height:"25px"}} onClick={() => {  setEdit(true); setDel(false); setOpen(true)}}/>
        </Grid>
        {/* <Grid item id={occurrenceStart["id"]+"menu"} style={{position: "relative",top:"-7.5px", visibility:"visible"}}>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={() => { handleClose(); setEdit(true); setDel(false); setOpen(true)}}>{I18n.get("edit")}</MenuItem>
                <MenuItem style={{color:"red"}} onClick={()=>{handleClose(); setEdit(true); setDel(true); setOpen(true)}}>{I18n.get("delete")}</MenuItem>
              </Menu>
        </Grid> */}
        <Grid container direction="column" wrap="nowrap" id={occurrenceStart["id"]} onClick={() => setOpen(true)}>
          <Grid
            item
            className={classes.time}
            id={occurrenceStart["id"]}
            style={{
              backgroundColor: borderColor,
              borderBottom: !backgroundColor
                ? `1px solid ${colors.veryLighPink}`
                : "none",
            }}
          >
            {formatDate(getOccurrenceStart(group), "hh:mm a")}
          </Grid>
          <Grid
            item
            id={occurrenceStart["id"]}
            style={{
              padding: "4px 0px",
              height: exceptionHeight - 40,
              display: exceptionHeight - 40 < 0 ? "none" : "",
              overflow: "hidden",
            }}
          >
            <Grid
              container
              direction={calendarView === calendarViews.weekly ? "row" : "column"}
              id={occurrenceStart["id"]}
            >
              <Grid
                item
                id={occurrenceStart["id"]}
                className={clsx({
                  [classes.dataColumnDaily]: calendarView === calendarViews.daily,
                  [classes.dataColumnWeekly]:
                    calendarView === calendarViews.weekly,
                })}
              >
                <Grid
                  container
                  id={occurrenceStart["id"]}
                  direction={
                    calendarView === calendarViews.weekly ? "column" : "row"
                  }
                  alignItems="center"
                  wrap="nowrap"
                >
                  <Grid item id={occurrenceStart["id"]}>
                    <img src={images.humanIconBlack} alt="human" height="12px" id={occurrenceStart["id"]} />
                  </Grid>
                  <Grid
                    item
                    id={occurrenceStart["id"]}
                    className={clsx({
                      [classes.textDaily]: calendarView === calendarViews.daily,
                      [classes.textWeekly]: calendarView === calendarViews.weekly,
                    })}
                  >
                    {`${get(hostProfile, ["firstname"])} ${get(hostProfile, [
                      "lastname",
                    ])}`}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                id={occurrenceStart["id"]}
                className={clsx({
                  [classes.dataColumnDaily]: calendarView === calendarViews.daily,
                  [classes.dataColumnWeekly]:
                    calendarView === calendarViews.weekly,
                })}
              >
                <Grid
                  container
                  id={occurrenceStart["id"]}
                  direction={
                    calendarView === calendarViews.weekly ? "column" : "row"
                  }
                  alignItems="center"
                  wrap="nowrap"
                >
                  <Grid item id={occurrenceStart["id"]}>
                    <img src={images.locationIcon} alt="location" height="12px" id={occurrenceStart["id"]} />
                  </Grid>
                  <Grid
                    item
                    id={occurrenceStart["id"]}
                    className={clsx({
                      [classes.textDaily]: calendarView === calendarViews.daily,
                      [classes.textWeekly]: calendarView === calendarViews.weekly,
                    })}
                  >
                    {get(occurrenceStart, ["zones", 0, "zone", "name"])}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                id={occurrenceStart["id"]}
                className={clsx({
                  [classes.dataColumnDaily]: calendarView === calendarViews.daily,
                  [classes.dataColumnWeekly]:
                    calendarView === calendarViews.weekly,
                })}
              >
                <Grid
                  container
                  id={occurrenceStart["id"]}
                  direction={
                    calendarView === calendarViews.weekly ? "column" : "row"
                  }
                  alignItems="center"
                  wrap="nowrap"
                >
                  <Grid item id={occurrenceStart["id"]}>
                    <img
                      id={occurrenceStart["id"]}
                      src={images.pedestrianIcon}
                      alt="pedestrian"
                      height="12px"
                    />
                  </Grid>
                  <Grid
                    item
                    id={occurrenceStart["id"]}
                    className={clsx({
                      [classes.textDaily]: calendarView === calendarViews.daily,
                      [classes.textWeekly]: calendarView === calendarViews.weekly,
                    })}
                  >
                    {size(
                      filter(
                        get(occurrenceStart, ["profiles"]),
                        (p) => get(p, ["association_type", "id"]) === 2
                      )
                    )}
                  </Grid>
                  {getAttributeValue(occurrenceStart, 19) && (
                    <Grid item style={{ marginTop: "24px" }} id={occurrenceStart["id"]}>
                      <img src={images.commentIconBlack} alt="comments" />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            id={occurrenceStart["id"]}
            className={classes.time}
            style={{
              backgroundColor: borderColor,
              borderTop: !backgroundColor
                ? `1px solid ${colors.veryLighPink}`
                : "none",
            }}
          >
            {formatDate(getOccurrenceEnd(group), "hh:mm a")}
          </Grid>
        </Grid>
      </Grid>
    );
  }

  
};

export default withStyles(styles)(SchedulerException);
